import createNotification, { ActiveNotice, Notification } from './toast';


let notification: Notification;
const notice = (
  type: ActiveNotice['type'],
  content: ActiveNotice['content'],
  duration: ActiveNotice['duration'] = 2000,
  onClose: ActiveNotice['onClose']
) => {
  if (!notification) {
    notification = createNotification();
  }
  return notification.addNotice({ type, content, duration, onClose });
}

type ToastMethod = (
  content: ActiveNotice['content'],
  duration?: ActiveNotice['duration'],
  onClose?: ActiveNotice['onClose']
) => ActiveNotice;

const Toast = {
  info: function(content, duration, onClose) {
    return notice('info', content, duration, onClose);
  } as ToastMethod,
  success: function(content = '操作成功', duration, onClose) {
    return notice('success', content, duration, onClose);
  } as ToastMethod,
  error: function(content, duration, onClose) {
    return notice('error', content, duration, onClose);
  } as ToastMethod,
  loading: function(content = '加载中...', duration = 0, onClose) {
    return notice('loading', content, duration, onClose);
  } as ToastMethod
}

export default Toast;
